import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import cer1 from "../../../assets/images/cer1.png";
import cer2 from "../../../assets/images/cer2.png";
import cer3 from "../../../assets/images/cer3.png";
import cer4 from "../../../assets/images/cer4.png";
import cer5 from "../../../assets/images/cer5.png";
import "./index.scss";
const NosCertification = () => {
  const [slidesToShow, setSlidesToShow] = useState(4);
  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 480) setSlidesToShow(2);
    else if (width <= 768) setSlidesToShow(3);
    else if (width <= 1350) setSlidesToShow(2);
    else setSlidesToShow(3);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settingsRow1 = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: slidesToShow, // Nombre d'images visibles en même temps
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false, // Direction de droite à gauche
    pauseOnHover: false,
  };
  const rows1 = [
    { id: 1, image: cer1, alt: " certification 1" },
    { id: 2, image: cer2, alt: " certification 2" },
    { id: 3, image: cer3, alt: "certification 3" },
    { id: 4, image: cer4, alt: "certification 4" },
    { id: 5, image: cer5, alt: "certification 5" },
  ];
  return (
    <>
      <div className="client-section">
        <div className="row ms-0  gx-0">
          <div className=" col-xl-3 col-md-4 mx-auto mt-5 mb-md-5 mb-0">
            {" "}
            <p className="serviceH-title  ">
              NOS
              <br />
              CERTIFICATIONS
            </p>
          </div>
          <div className=" col-xl-9 col-md-8  mx-auto mt-5 mb-md-5 mb-0">
            <Slider {...settingsRow1}>
              {rows1.map((row) => (
                <div key={row.id} className="row-slider3">
                  <img
                    src={row.image}
                    alt={row.alt}
                    className="image-hover-effect"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default NosCertification;
